import { Check } from "lucide-react";

export const VisibilitySection = ({ formData, update, breederProfile }) => {
  const isPremium =
    breederProfile?.subscription_tier === "royalty" || breederProfile?.subscription_tier === "elite";
  if (!isPremium) return null;

  return (
    <div className="glass-card p-6">
      <h3 className="text-xl text-[#EDEDED] mb-4 flex items-center gap-2">
        <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
        Listing Visibility
      </h3>
      <p className="text-sm text-[#71717A] mb-4">
        As a {breederProfile?.subscription_tier} member, you can create private listings with invite-only access.
      </p>
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => update({ visibility: "public" })}
          className={`p-4 rounded-lg border transition-all text-left ${
            formData.visibility === "public"
              ? "border-[#D4AF37] bg-[#D4AF37]/10"
              : "border-[#3F3F46] hover:border-[#71717A]"
          }`}
          data-testid="visibility-public"
        >
          <div className="flex items-center gap-2 mb-1">
            <svg className="w-5 h-5 text-[#22C55E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span className={formData.visibility === "public" ? "text-[#D4AF37]" : "text-[#EDEDED]"}>
              Public
            </span>
            {formData.visibility === "public" && <Check className="w-4 h-4 text-[#D4AF37] ml-auto" />}
          </div>
          <p className="text-xs text-[#71717A]">Visible to all users on the marketplace</p>
        </button>
        <button
          type="button"
          onClick={() => update({ visibility: "private" })}
          className={`p-4 rounded-lg border transition-all text-left ${
            formData.visibility === "private"
              ? "border-[#D4AF37] bg-[#D4AF37]/10"
              : "border-[#3F3F46] hover:border-[#71717A]"
          }`}
          data-testid="visibility-private"
        >
          <div className="flex items-center gap-2 mb-1">
            <svg className="w-5 h-5 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
            <span className={formData.visibility === "private" ? "text-[#D4AF37]" : "text-[#EDEDED]"}>
              Private
            </span>
            {formData.visibility === "private" && <Check className="w-4 h-4 text-[#D4AF37] ml-auto" />}
          </div>
          <p className="text-xs text-[#71717A]">Invite-only access via unique codes</p>
        </button>
      </div>
      {formData.visibility === "private" && (
        <div className="mt-4 p-3 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/30">
          <p className="text-sm text-[#D4AF37]">
            ✨ Private listing! After creating, you can generate invite codes from your dashboard.
          </p>
        </div>
      )}
    </div>
  );
};
